import { Link, useLocation } from "react-router-dom";
import { HiChevronRight } from "react-icons/hi";

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const getBreadcrumbs = () => {
    let path = "";
    const crumbs = [{ name: "Home", path: "/dashboard" }];
    for (let i = 0; i < pathSegments.length; i++) {
      path += `/${pathSegments[i]}`;
      const name = pathSegments[i]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      crumbs.push({ name, path });
    }
    return crumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav className="flex items-center space-x-2 text-sm">
      {breadcrumbs.map((item, index) => (
        <div key={index} className="flex items-center">
          {index > 0 && <HiChevronRight className="mx-2 text-gray-400" />}
          <Link
            to={item.path}
            className={`font-medium transition-colors ${
              index === breadcrumbs.length - 1
                ? "text-primary cursor-default"
                : "text-gray-500 hover:text-primary"
            }`}
          >
            {item.name}
          </Link>
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;
